module.exports = __webpack_public_path__ + "img/gmsyt5.88cafe59.png";